import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '@finn/design-system/atoms/modal';
import { RawHtml } from '@finn/platform-modules';
import { PRELOVED_LABEL } from '@finn/ua-constants';
import { SyntheticEvent, useState } from 'react';

import { GenericVehicleDetails } from '../../core/types';
import { PDPTracking } from '../tracking/PDPTracking';
import { ContactUsBox } from './ContactUsBox';

type ModalData = {
  modal_title: string;
  modal_text: string;
};

type Props = {
  open: boolean;
  onClose: (event?: SyntheticEvent) => void;
  data: ModalData;
};

export const isPreloved = (vehicle: GenericVehicleDetails) =>
  vehicle.product_label?.label &&
  vehicle.product_label.label.includes(PRELOVED_LABEL);

export const PreLovedInfo = ({ pdpData }: any) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleInfoClick = (event: SyntheticEvent | undefined) => {
    PDPTracking.helpOptionClicked('preloved');
    setModalOpen(true);
    event?.stopPropagation?.();
  };

  const handleModalClose = (event: SyntheticEvent | undefined) => {
    setModalOpen(false);
    event?.stopPropagation();
  };

  const { description, link, modal_text, modal_title } =
    pdpData?.metadata?.content?.preloved || {};

  return (
    <div className="bg-snow my-4 py-5 pl-4 pr-5">
      <span className="body-14-regular inline">
        <RawHtml html={description} />
        <a
          href="javascript:void(0)"
          className="link-14"
          onClick={handleInfoClick}
        >
          {link}
        </a>
      </span>
      <PreLovedModal
        open={modalOpen}
        onClose={(event) => {
          handleModalClose(event);
        }}
        data={{
          modal_title,
          modal_text,
        }}
      />
    </div>
  );
};

export const PreLovedModal = ({
  open,
  onClose,
  data: { modal_text, modal_title },
}: Props) => {
  return (
    <Modal
      open={open}
      onOpenChange={(isOpen) => {
        !isOpen && onClose();
      }}
    >
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{modal_title}</ModalTitle>
        </ModalHeader>
        <span className="body-16-light">
          <RawHtml html={modal_text} />
        </span>
        <ModalFooter>
          <ContactUsBox />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
